import Init from './Initer';
import TH_IntlTelInput from '_tradeholding/js/Classes/IntlTelInput';

Init.addRegister('phonenumber-input', TH_IntlTelInput.initMultiple, TH_IntlTelInput);